var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Sistsoffa01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 182.78 113.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0 118.8 188.1 118.8 188.1 0 0 0 0 118.8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "26.82 34.56 91.38 34.56 91.38 100.68 26.82 100.68 26.82 34.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "91.38 34.56 155.94 34.56 155.94 100.68 91.38 100.68 91.38 34.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "155.94 25.11 166.98 25.11 166.98 95.97 155.94 95.97 155.94 25.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "26.82 25.14 15.81 25.14 15.81 95.97 26.82 95.97 26.82 25.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "15.81 15.69 166.98 15.69 166.98 25.11 15.81 25.11 15.81 15.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "26.82 25.14 155.94 25.14 155.94 34.56 26.82 34.56 26.82 25.14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Sistsoffa01);
export default __webpack_public_path__ + "static/media/2-sist soffa-01.8bafa4cc8d339b24447737ba4c45888d.svg";
export { ForwardRef as ReactComponent };